import { WorkSheet } from 'src/projects/hooks/composeExcelBuffer.ts';
import { Selection } from 'src/projects/types/Selection.ts';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { readSearchParam } from 'src/common/readSearchParam.ts';
import { LOCATION_STORE_PARAM_NAME } from 'src/common/constants.ts';
import { isArrayOfLocaleValuesFragment } from 'src/common/types/isArrayOfLocaleValuesFragment.ts';
import { numberFormatter } from 'src/utils/numberFormatter.ts';
import { isLocaleValuesFragment } from 'src/common/types/isLocaleValuesFragment.ts';
import { decodeHtml } from 'src/utils/decodeHtml.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { BelimoTranslate } from 'src/common/hooks/useBelimoTranslate.ts';
import { isLink } from 'shared/projects/isLink.ts';
import { Link } from 'shared/projects/Link.ts';
import { isArrayOfUnitValue } from 'shared/projects/isUnitValue.ts';

export const createReduceSelections = ({
    userSettings,
    t,
}: {
    userSettings: UserSettings;
    t: BelimoTranslate;
}) => (acc: WorkSheet, selection: Selection, i: number, all: Selection[]) => {
    if (i === 0 || (i > 0 && (selection.version || '') !== (all[i - 1].version || ''))) {
        const columnNames = selection.exportData.columns.map((key) => t(key).trim());
        columnNames.push(t(MESSAGES.Comment).trim());
        if (i > 0) {
            acc.rows.push([]);
        }
        acc.rows.push(columnNames);
    }
    const state = readSearchParam(
        new URLSearchParams(selection.searchQuery),
        LOCATION_STORE_PARAM_NAME,
        { checkoutComment: '' },
        (v) => !!v,
    );
    selection.exportData.rows.forEach((cells, index) => {
        const mapped = cells.map((cell) => {
            if (cell === null || cell === undefined) {
                return '';
            }
            if (isLink(cell)) {
                return cell;
            }
            let value: string | Link = `${cell}`.trim();
            if (isArrayOfLocaleValuesFragment(cell)) {
                value = cell.map((v) => t(v, false).trim()).join(', ');
            } else if (isArrayOfUnitValue(cell)) {
                value = cell.map((r) => {
                    const [v, u] = r;
                    return `${numberFormatter(v, userSettings.currentLocale)} ${t(u, false)}`;
                }).join(', ');
            } if (isLocaleValuesFragment(cell)) {
                value = t(cell, false);
            }
            return decodeHtml(value);
        });
        if (index === 0) {
            mapped.push('');
            mapped.push(state.checkoutComment);
        }
        acc.rows.push(mapped);
        acc.columns = Array.from({ length: Math.max(acc.columns.length, mapped.length) }).map(() => ({
            width: 15,
        }));
    });

    return acc;
};
